import React, { useCallback, useState } from "react";
import { Modal } from "antd";
import { inject, observer } from "mobx-react";
import { History } from "history";
import { HOMEPAGE_PATH } from "../constants/auth";
import { IAppStore } from "../stores/Interfaces";
import logoImage from "../images/logo.png";
import ResetPasswordForm from "../components/forms/ResetPassword";
import LoginForm from "../components/forms/LoginForm";

interface Props {
  history: History;
  store?: IAppStore;
}

const LoginPage: React.FC<Props> = ({ history }) => {
  const [visibleResetPasswordForm, setVisibleResetPasswordForm] = useState(
    false
  );

  const showResetPasswordForm = useCallback(() => {
    setVisibleResetPasswordForm(true);
  }, []);

  const hideResetPasswordForm = useCallback(() => {
    setVisibleResetPasswordForm(false);
  }, []);

  const onLoginHandler = useCallback(() => history.push(HOMEPAGE_PATH), [
    history,
  ]);

  return (
    <div className="login-page">
      <div className="login-page__card">
        <img
          src={logoImage}
          alt={`${process.env.REACT_APP_NAME} logo`}
          className="login-page__logo"
        />
        <LoginForm
          onShowResetModal={showResetPasswordForm}
          onLogin={onLoginHandler}
        />
        <Modal
          title="Recover password"
          footer={null}
          onCancel={hideResetPasswordForm}
          visible={visibleResetPasswordForm}
        >
          <ResetPasswordForm onFinish={hideResetPasswordForm} />
        </Modal>
      </div>
    </div>
  );
};

export default inject("store")(observer(LoginPage));
